import { action } from 'typesafe-actions';
// eslint-disable-next-line no-unused-vars
import { asyncAction } from 'store/utils/promiseAction';
import { SectionsTypes, SectionInterface } from './types';

// List Sections
export const listSectionsRequest = (payload: {
  body?: object;
  filtering?: boolean;
}) => action(SectionsTypes.LIST_SECTIONS_REQUEST, payload);
// eslint-disable-next-line max-len
export const listSectionsSuccess = (payload: {
  sectionsList: SectionInterface[];
  totalCount: number;
}) => action(SectionsTypes.LIST_SECTIONS_SUCCESS, payload);
export const listSectionsFailure = () =>
  action(SectionsTypes.LIST_SECTIONS_FAILURE);

// Get Section
export const getSectionRequest = (payload: any) =>
  action(SectionsTypes.GET_SECTION_REQUEST, payload);
export const getSectionSuccess = (payload: { sectionData: SectionInterface }) =>
  action(SectionsTypes.GET_SECTION_SUCCESS, payload);
export const getSectionFailure = () =>
  action(SectionsTypes.GET_SECTION_FAILURE);

// Filter Sections
export const filterSectionsRequest = (payload: object) =>
  action(SectionsTypes.FILTER_SECTIONS_REQUEST, payload);
export const filterSectionsSuccess = (payload: {
  sectionsList: SectionInterface[];
  totalCount: number;
}) => action(SectionsTypes.FILTER_SECTIONS_SUCCESS, payload);
export const filterSectionsFailure = () =>
  action(SectionsTypes.FILTER_SECTIONS_FAILURE);

// Create Section
export const createSectionRequest = (payload: object) =>
  action(SectionsTypes.CREATE_SECTION_REQUEST, payload);
export const createSectionSuccess = (payload: {
  sectionCreated: SectionInterface;
}) => action(SectionsTypes.CREATE_SECTION_SUCCESS, payload);
export const createSectionFailure = () =>
  action(SectionsTypes.CREATE_SECTION_FAILURE);

// Create Sections
export const createSectionsRequest = (payload: { sections: object[] }) =>
  asyncAction(SectionsTypes.CREATE_SECTIONS_REQUEST, payload);
export const createSectionsSuccess = () =>
  action(SectionsTypes.CREATE_SECTIONS_SUCCESS);
export const createSectionsFailure = () =>
  action(SectionsTypes.CREATE_SECTIONS_FAILURE);

// Update Section
export const updateSectionRequest = (payload: object) =>
  action(SectionsTypes.UPDATE_SECTION_REQUEST, payload);
export const updateSectionSuccess = (payload: {
  sectionData: SectionInterface;
}) => action(SectionsTypes.UPDATE_SECTION_SUCCESS, payload);
export const updateSectionFailure = () =>
  action(SectionsTypes.UPDATE_SECTION_FAILURE);

// Delete Section
export const deleteSectionRequest = (payload: object) =>
  action(SectionsTypes.DELETE_SECTION_REQUEST, payload);
export const deleteSectionSuccess = () =>
  action(SectionsTypes.DELETE_SECTION_SUCCESS);
export const deleteSectionFailure = () =>
  action(SectionsTypes.DELETE_SECTION_FAILURE);
